import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class PageTitle extends React.Component {
    state = {
        defaultTitle: document?.title,
    }

    componentDidMount() {
        document.title = this.props.title || this.state.defaultTitle;
    }

    componentDidUpdate() {
        document.title = this.props.title || this.state.defaultTitle;
    }

    render() {
        return null;
    }
}

PageTitle.propTypes = {
    title: PropTypes.string,
};

PageTitle.defaultProps = {
    title: null,
};

const mapStateToProps = state => ({
    currentPath: state.pageSettings.pathname, // Sets this to trigger update on navigation
});

export default connect(mapStateToProps)(PageTitle);
